/*
 * 機能名：日計表出力
 */

import DdDateBox from '@/components/DdDateBox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdFooterButton from '@/components/DdFooterButton'
import DdSubHeader from '@/components/DdSubHeader'

import validators from '@/rahmen/validators'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import modals from '@/ddv2.library/modals'
import message from '@/ddv2.library/messages'

export default {
  name: 'NikkeihyoOutput',
  mixins: [flowMixin],
  data: () => ({
    conditions: {
      shutsuryokuStartYmdString: '',
      shutsuryokuEndYmdString: ''
    },
    dispNikkeihyoCsvNm: '',
    dispNikkeihyoExcelNm: '',
    modeKengen: 0
  }),
  components: {
    DdDateBox,
    DdDefaultButton,
    DdFooterButton,
    DdSubHeader
  },
  computed: {
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: [],
        initializeInputPromise: (c) => {
          this.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('D2BZMD0020.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('D2BZMD0020.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        restoreViewPromise: (c) => {
          console.log('D2BZMD0020.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
      })
      this.Effects.loadComplete()
    },
    onCsvButtonClick: function (e) {
      this.clearSummaryMessage()
      if (!this.outputValidate) { return }
      console.log(e)
      this.Effects.loadStart()
      this.dispNikkeihyoCsvNm = `日計表_${this.getTimeStamp()}.csv`
      // todo:レポート出力
      this.HttpClient
        .requestFileByPost('/api/v1/vwCD2bzmd0020/Download', this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const bom = new Uint8Array([0xef, 0xbb, 0xbf])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0007')
          this.Effects.loadComplete()
        })
    },
    onExcelButtonClick: function (e) {
      this.clearSummaryMessage()
      if (!this.outputValidate) { return }
      console.log(e)
      this.Effects.loadStart()
      this.dispNikkeihyoExcelNm = `日計表_${this.getTimeStamp()}.xlsm`
      // todo:レポート出力
      this.HttpClient
        .requestFileByPost('/api/v1/vwCD2bzmd0020/ExcelOutput', this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const blob = new Blob([data], { type: 'application/vnd.ms-excel.sheet.macroEnabled.12' })
          const elem = document.getElementById('excelDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0007')
          this.Effects.loadComplete()
        })
    },
    initBindVariables: function () {
      this.conditions = {
        shutsuryokuStartYmdString: filter.dateFormatter(new Date()),
        shutsuryokuEndYmdString: filter.dateFormatter(new Date())
      }
    },
    outputValidate: function () {
      if (this.conditions.shutsuryokuStartYmdString && this.conditions.shutsuryokuEndYmdString) {
        var msg = validators.compareYearMonth(this.conditions.shutsuryokuStartYmdString, this.conditions.shutsuryokuEndYmdString)
        if (msg !== undefined) {
          this.$refs.shutsuryokuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.shutsuryokuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      } else if (!this.conditions.shutsuryokuStartYmdString) {
        this.$refs.shutsuryokuStartYmdString[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      } else if (!this.conditions.shutsuryokuEndYmdString) {
        this.$refs.shutsuryokuEndYmdString[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      return true
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
